import { render, staticRenderFns } from "./AreaInput.vue?vue&type=template&id=127b4c59&"
import script from "./AreaInput.vue?vue&type=script&lang=ts&"
export * from "./AreaInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports